
import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Shield, Link as LinkIcon } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';

const Privacy = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow pt-28 pb-16">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <div className="mb-4 flex justify-center">
              <Shield className="h-12 w-12 text-apple-blue" />
            </div>
            <h1 className="text-4xl font-bold text-apple-text mb-4">
              Privacy Policy
            </h1>
            <p className="text-xl text-apple-text-secondary max-w-3xl mx-auto">
              Last updated: {new Date().toLocaleDateString('en-US', {month: 'long', day: 'numeric', year: 'numeric'})}
            </p>
          </div>

          <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-sm p-8 mb-12">
            <div className="prose prose-apple mx-auto">
              <h2>Introduction</h2>
              <p>
                True Talent Apply ("we," "our," or "us") respects your privacy and is committed to protecting your personal data. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our recruitment platform.
              </p>
              <p>
                Please read this Privacy Policy carefully. If you do not agree with the terms of this Privacy Policy, please do not access the site.
              </p>

              <h2>Information We Collect</h2>
              <p>We collect information that you provide directly to us, including:</p>
              <ul>
                <li>Personal identifiers (name, email address, phone number)</li>
                <li>Professional or employment-related information (resume, work history, education)</li>
                <li>Video introductions and assessment responses</li>
                <li>Account credentials</li>
                <li>Demographic information</li>
              </ul>

              <p>We may also automatically collect certain information when you visit our website, including:</p>
              <ul>
                <li>IP address and browser information</li>
                <li>Device information</li>
                <li>Usage data</li>
                <li>Cookies and similar technologies</li>
              </ul>

              <h2>How We Use Your Information</h2>
              <p>We use the information we collect for various purposes, including to:</p>
              <ul>
                <li>Provide, maintain, and improve our services</li>
                <li>Process job applications and facilitate the recruitment process</li>
                <li>Communicate with you about our services</li>
                <li>Analyze usage patterns and optimize user experience</li>
                <li>Comply with legal obligations</li>
                <li>Prevent fraud and protect the security of our platform</li>
              </ul>

              <h2>Sharing Your Information</h2>
              <p>We may share your information with:</p>
              <ul>
                <li>Potential employers when you apply for positions</li>
                <li>Service providers who perform services on our behalf</li>
                <li>Professional advisors</li>
                <li>In response to legal process or when required by law</li>
                <li>In connection with a merger, sale, or acquisition</li>
              </ul>

              <h2>Data Retention</h2>
              <p>
                We retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required by law or for legitimate business purposes.
              </p>

              <h2>Your Rights</h2>
              <p>Depending on your location, you may have certain rights regarding your personal information, including:</p>
              <ul>
                <li>Access to your personal data</li>
                <li>Correction of inaccurate information</li>
                <li>Deletion of your personal data</li>
                <li>Restriction or objection to processing</li>
                <li>Data portability</li>
              </ul>

              <p>
                To exercise these rights, please contact us using the information provided in the "Contact Us" section below.
              </p>

              <h2>Security</h2>
              <p>
                We implement appropriate technical and organizational measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure, so we cannot guarantee absolute security.
              </p>

              <h2>Changes to This Policy</h2>
              <p>
                We may update this Privacy Policy from time to time. The updated version will be indicated by an updated "Last Updated" date and will be accessible on our website.
              </p>

              <h2>Contact Us</h2>
              <p>
                If you have questions or concerns about this Privacy Policy, please contact us.
              </p>
              <div className="mt-6 text-center">
                <Button asChild className="bg-apple-blue hover:bg-apple-blue/90">
                  <Link to="/contact">Contact Us</Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Privacy;
